/* eslint-disable no-param-reassign */
import { ensureStructure } from '../../../helpers/ComponentHelper.js'

const onUGCLoaded = (props, window) => {
  ensureStructure(window)
  const { tags } = props
  const id = 'M024'
  const ugc = {
    id,
    filters: tags.map((tag) => ({
      label: tag,
      type: '',
      selected: false
    }))
  }

  const eventName = 'ugcLoaded'
  const eventAction = 'User Generated Content Loaded'
  const event = {
    eventInfo: {
      eventName,
      eventAction
    }
  }
  window.digitalData.page.ugc = ugc
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName)
}

const onPDPUGCLoaded = (productIdentifier, window) => {
  ensureStructure(window)
  const id = 'C002'
  const ugc = {
    id,
    filters: productIdentifier
  }

  const eventName = 'ugcLoaded'
  const eventAction = 'User Generated Content Loaded'
  const event = {
    eventInfo: {
      eventName,
      eventAction
    }
  }
  window.digitalData.page.ugc = ugc
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName)
}

const onUGCViewed = (window) => {
  ensureStructure(window)
  const eventName = 'ugcViewed'
  const eventAction = 'User Generated Content Viewed'
  const event = {
    eventInfo: {
      eventName,
      eventAction
    }
  }
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName)
}

const formatTagLabel = (label) => label.replace(/home-/g, '').replace(/bedroom/g, ' bedroom')

const onUGCFilterInteraction = (props, selectedTags, selectedTag, window) => {
  ensureStructure(window)
  const { tags } = props
  const id = 'M024'
  const filters = tags.map((tag) => ({
    label: tag,
    type: '',
    selected: selectedTags.includes(formatTagLabel(tag))
  }))
  const ugc = {
    id,
    filters
  }

  const eventName = 'ugcInteraction'
  const eventAction = 'User Generated Filters Interaction'
  const event = {
    eventInfo: {
      eventName,
      eventAction
    },
    attributes: {
      interaction: 'filter',
      filter: {
        label: formatTagLabel(selectedTag),
        type: '',
        selected: true
      }
    }
  }
  window.digitalData.page.ugc = ugc
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName)
}

const onQuickViewSlidingPanelOpen = (products, included, trackingOptions, window) => {
  ensureStructure(window)
  window.digitalData.page.lightBox.type = trackingOptions.type
  window.digitalData.page.lightBox.clickOrigin = trackingOptions.clickOrigin
  window.digitalData.page.lightBox.currentTab = trackingOptions.currentTab
  window.digitalData.page.lightBox.product = products.map((product) => {
    const prices = included.find((inc) => inc.type === 'prices' && inc.id === product.id)
    return {
      id: product.id,
      price: prices.attributes.now
    }
  })
  const event = {
    eventInfo: {
      eventName: trackingOptions.eventName
    }
  }
  window.digitalData.event.push(event)
  window.digitalData.track(trackingOptions.eventName)
}

const onQuickViewSlidingPanelShut = (window) => {
  ensureStructure(window)
  window.digitalData.page = {
    ...window.digitalData.page,
    lightBox: {}
  }
}

export {
  ensureStructure,
  onQuickViewSlidingPanelOpen,
  onQuickViewSlidingPanelShut,
  onUGCLoaded,
  onUGCViewed,
  onUGCFilterInteraction,
  onPDPUGCLoaded
}
